import { ReviewItem, Room } from '../types';
import { safeNegativeId } from '../utils/idUtils';
import { OnDemandItemInput } from './reviewCoreApi';

const DEFAULT_ON_DEMAND_DISPLAY_ORDER = 999;

export const buildOfflineRoom = (
  propertyId: number,
  name: string,
  tempId: string
): Room => ({
  id: safeNegativeId(tempId),
  propertyId,
  name,
  displayOrder: 0,
  isCustom: true,
  tempId,
});

export const buildOfflineOnDemandReviewItem = (
  reviewId: number,
  itemId: number,
  data: OnDemandItemInput,
  tempId?: string
): ReviewItem => ({
  id: tempId ? safeNegativeId(tempId) : itemId,
  categoryId: data.categoryId || 0,
  name: data.name,
  description: data.description,
  questionsSchema: data.questionsSchema || {},
  displayOrder: DEFAULT_ON_DEMAND_DISPLAY_ORDER,
  isRequired: false,
  defaultPresent: false,
  isOnDemand: true,
  homeReviewId: reviewId,
  ...(tempId ? { tempId } : {}),
});
